<template>
    <div>
        <app-widget-with-icon v-if="type === 'app-widget-with-icon'" :data="$props"/>
        <app-widget-without-icon v-else-if="type === 'app-widget-without-icon'" :data="$props"/>
        <app-widget-with-circle v-else-if="type === 'app-widget-with-circle'" :data="$props"/>

    </div>
</template>

<script>
	import AppWidgetWithIcon from "./AppWidgetWithIcon.vue";
    import AppWidgetWithoutIcon from "./AppWidgetWithoutIcon.vue";
    import AppWidgetWithCircle from "./AppWidgetWithCircle.vue";
	export default {
		name: "Index",
		components: {
            AppWidgetWithIcon,
            AppWidgetWithoutIcon,
            AppWidgetWithCircle,
        },
		props: {
			type: {
                required: true,
                type: String
            },
			label: {
				type: String,
				required: true,
			},
			number: {
				required: false,
			},

			icon: {
				type: String,
			},
			data :{
				type: Object,
				required: false
			}
		}
	}
</script>